var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCopyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38636 15.6148L15.6148 8.38636M5.67492 11.0965L3.86814 12.9033C3.39352 13.3779 3.01703 13.9414 2.76016 14.5615C2.5033 15.1816 2.37109 15.8463 2.37109 16.5175C2.37109 17.1887 2.5033 17.8534 2.76016 18.4735C3.01703 19.0936 3.39352 19.6571 3.86814 20.1317C4.34276 20.6063 4.90622 20.9828 5.52635 21.2397C6.14647 21.4965 6.81112 21.6287 7.48234 21.6287C8.15355 21.6287 8.8182 21.4965 9.43832 21.2397C10.0584 20.9828 10.6219 20.6063 11.0965 20.1317L12.9008 18.3249M11.0953 5.67492L12.902 3.86814C13.3767 3.39352 13.9401 3.01703 14.5602 2.76016C15.1804 2.5033 15.845 2.37109 16.5162 2.37109C17.1874 2.37109 17.8521 2.5033 18.4722 2.76016C19.0923 3.01703 19.6558 3.39352 20.1304 3.86814C20.605 4.34277 20.9815 4.90622 21.2384 5.52635C21.4953 6.14647 21.6275 6.81112 21.6275 7.48234C21.6275 8.15356 21.4953 8.8182 21.2384 9.43833C20.9815 10.0585 20.605 10.6219 20.1304 11.0965L18.3236 12.9033",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCopyIcon);
export default __webpack_public_path__ + "static/media/greenCopyIcon.96ee58486af780e2ad44e569629dcc7c.svg";
export { ForwardRef as ReactComponent };